import { FC } from 'react';
import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { Metatags } from '../../Layout/Metatags';
import { PersonFragment } from '../../../generated/types';
import { Image } from '../../Common/Image';
import { HTMLText } from '../../Common/HTMLText';

interface PersonProps {
  data: PersonFragment;
}

export const Person: FC<PersonProps> = ({ data }) => {
  const hasImage = Boolean(data.photo);

  return (
    <>
      <Metatags metatags={data.metatags} />
      <Container maxW="container.main" py={9}>
        <Grid
          templateColumns="repeat(12, 1fr)"
          gap={{
            base: 4,
          }}
        >
          {hasImage && (
            <GridItem
              colSpan={{
                base: 12,
                md: 4,
              }}
            >
              <Image
                borderTopRadius="sm"
                imageStyle={data.photo!.imageStyle}
                image={data.photo!}
                hideCopyright
              />
            </GridItem>
          )}
          <GridItem
            colSpan={{
              base: 12,
              md: hasImage ? 8 : 4,
            }}
          >
            <Heading as="h1" color="primaryDark">
              {data.title}
            </Heading>
            {data.job && (
              <Wrap>
                {data.job.map((job, i) => {
                  if (!job) return null;

                  return <WrapItem key={i}>{job.title}</WrapItem>;
                })}
              </Wrap>
            )}
            <Box mt={4}>
              <HTMLText text={data.description} />
            </Box>
          </GridItem>
        </Grid>
      </Container>
    </>
  );
};
